/**
 * MarketPlaceholderPage — placeholder for the canonical 3rd page surface.
 *
 * Cycle 109 v2 Sprint 1 (CI-1 follow-up to /review-sprint sprint-203).
 * Wires the `/market` route so NavRail + CmdK navigation lands on a real page
 * (not the catch-all redirect to /workspace). Replaced when the Market
 * surface ships in a later cycle.
 *
 * Reference: design_handoff_echelon_2026_04_26/Market.html (canonical surface).
 */
export function MarketPlaceholderPage() {
  return (
    <div
      data-testid="market-placeholder"
      style={{
        padding: 32,
        minHeight: '100vh',
        background: 'var(--bg)',
        color: 'var(--fg)',
        fontFamily: 'var(--font-sans)',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
      }}
    >
      <h1
        className="display"
        style={{
          margin: 0,
          fontSize: 28,
          letterSpacing: '-0.01em',
          color: 'var(--fg)',
        }}
      >
        Market
      </h1>
      <p
        className="mono"
        style={{
          margin: 0,
          fontSize: 11,
          letterSpacing: '0.14em',
          textTransform: 'uppercase',
          color: 'var(--fg-muted)',
        }}
      >
        Forecasts · forensics · feeds
      </p>
      <p style={{ marginTop: 16, color: 'var(--fg-secondary)', fontSize: 13, maxWidth: 520 }}>
        The canonical Market surface ships in a future cycle. Sprint-1 wires the
        navigation entry + route so design-system primitives can be composed against a
        real destination.
      </p>
    </div>
  );
}

export default MarketPlaceholderPage;
